import { ListFilter } from './filter.model';
import { SearchHighlights } from './search-highlight.model';

export interface NewsFilter extends ListFilter {}

export class NewsFilterModel {
    skip: number;
    take: number;
    paging: boolean;
    startDate?: string;
    endDate?: string;
    searchString?: string;

    constructor(private model: NewsFilter) {
        this.skip = model.skip || 0;
        this.take = model.take || 10;
        this.paging = model.paging || true;
        this.startDate = model.startDate || '';
        this.endDate = model.endDate || '';
        this.searchString = model.searchString || '';
    }
}

export interface News {
    id: string;
    lastUpdateDate: string;
    title: string;
    tags: string[];
    details: string;
    sources: NewsSource[];
    /** Optional highlights returned from search API */
    highlights?: SearchHighlights;
    /** Array of matched search tokens */
    matchedTokens?: string[];
}

export class NewsModel {
    id: string;
    lastUpdateDate: string;
    title: string;
    tags: string[];
    details: string;
    sources: NewsSourceModel[];
    isShow: boolean;
    /** Optional highlights returned from search API */
    highlights?: SearchHighlights;
    /** Array of matched search tokens */
    matchedTokens?: string[];

    constructor(private model: News) {
        this.id = model.id;
        this.lastUpdateDate = model.lastUpdateDate;
        this.title = model.title;
        this.tags = model.tags;
        this.details = model.details;
        this.sources = model.sources ? model.sources.map((m) => new NewsSourceModel(m)) : [];
        this.isShow = false;
        this.highlights = model.highlights;
        this.matchedTokens = model.matchedTokens;
    }
}

export interface NewsSource {
    title: string;
    url: string;
}

export class NewsSourceModel {
    title: string;
    url: string;

    constructor(private model: NewsSource) {
        this.title = model.title;
        this.url = model.url;
    }
}
